export var isEmptyRendering = function isEmptyRendering(_ref) {
  var builders = _ref.builders,
    sellers = _ref.sellers;
  return builders.length + sellers.length === 0;
};